import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { EConfigurations } from "../../../../../shared/oversight-core/enums/configurations";
import { IBrandPriority } from "../../../../../shared/oversight-core/interfaces/brand-priority";
import { Configurations } from "../../../../../shared/oversight-core/interfaces/configurations";
import AppSwitch from "../../../../../shared/oversight-core/ui-elements/app-switch/app-switch";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import { configurationDescription } from "../../../../../shared/oversight-core/utils/configuration-description";
import translate from "../../../../../shared/oversight-core/utils/translate";
import UserBrandPriorityChangeModal from "../user-brand-priority-change-modal/user-brand-priority-change-modal";

interface IExtendedBrandPriority extends IBrandPriority {
  id: number;
}

interface IProps extends ModelContainerProps {
  show: boolean;
  userId: string;
  configurations: Configurations;
}

const UserPreferencesModal = (props: IProps) => {
  const { show, configurations, ...rest } = props;

  const [brands, setBrands] = useState<IExtendedBrandPriority[]>([]);
  const [isShowBrandPriorityChangeModal, setIsShowBrandPriorityChangeModal] =
    useState(false);

  useEffect(() => {
    setBrands(
      Array.isArray(configurations.BRAND_PRIORITY_LIST)
        ? configurations.BRAND_PRIORITY_LIST.map((bp, index) => {
            return {
              ...bp,
              id: index,
            };
          })
        : []
    );
  }, [configurations]);

  return (
    <>
      <ModalContainer
        title="User Preferences"
        {...rest}
        show={show}
        size="modal-md"
        isButtonsVisible={false}
      >
        <>
          <Row>
            <Col className="title-3 font-weight-500">
              System Design Preferences
            </Col>
          </Row>
          {Object.entries(configurations).map(([configuration, value]) => {
            if (configuration === EConfigurations.BRAND_PRIORITY_LIST) {
              return null;
            }
            return (
              <Row className="mt-3" key={configuration}>
                <Col>
                  <Row>
                    <Col className="title-2 font-weight-500">
                      {translate(configuration)}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-color-2 font-size-12">
                      {configurationDescription(
                        configuration as EConfigurations
                      )}
                    </Col>
                  </Row>
                  {configuration === EConfigurations.BRAND_PRIORITY && (
                    <Row>
                      <Col
                        className="title-3 font-size-12 text-decoration-underline cursor-pointer"
                        onClick={() => {
                          setIsShowBrandPriorityChangeModal(true);
                        }}
                      >
                        Change Brand Priority
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col className="col-auto">
                  <AppSwitch
                    isOn={typeof value === "boolean" && value}
                    size="sm"
                    disabled
                  />
                </Col>
              </Row>
            );
          })}
        </>
      </ModalContainer>
      <UserBrandPriorityChangeModal
        show={isShowBrandPriorityChangeModal}
        onCancel={() => {
          setIsShowBrandPriorityChangeModal(false);
        }}
        onClose={() => {
          setIsShowBrandPriorityChangeModal(false);
        }}
        brands={brands}
        setBrands={setBrands}
      />
    </>
  );
};

export default UserPreferencesModal;
